import React, { Suspense } from 'react';
import ComponentAudio from './ComponentAudio';
const ComponentAudioLoader = (props) => {
    return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(ComponentAudio, Object.assign({}, props, { imageWidth: Number(props.imageWidth), posterImage: JSON.parse(props.poster), tracks: JSON.parse(props.tracks) }))));
};
ComponentAudioLoader.defaultProps = {
    viewtype: 'Auto',
};
export default ComponentAudioLoader;
